<template>
    <div>
        <div class="headline" v-html="products.relatedProductsTitle"></div>
        <div class="col-xs-12 no-padding">
            <div class="related-products-wrapper col-xs-12 no-padding">
                <template v-for="product in products.relatedProducts">
                    <a :href="'/'+locale+'/'+product['uid']" target="_blank"
                       class="col-xs-12 col-sm-6 col-md-6 col-lg-12 related-product-link no-padding"
                       :key="product.productName">
                        <div class="link-wrapper">
                            <div class="icon">
                                <span class="prodcard-icon" :class="product['icon_field']"></span>
                            </div>
                            <div class="text">
                                <span class="prodcard-name text-uppercase" v-html="product['product_name']"></span><br>
                                <span class="prodcard-price" v-html="product['product_price_text']"></span>
                            </div>
                        </div>
                    </a>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['products', 'headline', 'locale'],
    }
</script>

<style scoped>
    .related-products-wrapper {
        display: flex;
        flex-wrap: wrap;
    }

    .related-product-link {
        color: rgb(51, 51, 51);
        position: relative;
        min-height: 75px;
    }

    .related-product-link:not(:last-child) {
        border-bottom: 1px solid $color-blueish-black;
    }

    .link-wrapper {
        height: 100%;
        margin: auto;
        padding: 13px 0;
    }

    .prodcard-icon {
        font-size: 50px !important;
        margin: auto;
        padding-top: 0;
        position: absolute;
        top: calc(50% - 25px);
    }

    .prodcard-price {
        color: #7DBB97;
    }

    .prodcard-name {
        font-weight: 600;
        font-family: Montserrat, sans-serif;
    }

    .icon {
        display: block;
        width: 90px;
        margin-right: 10px;
        position: absolute;
        height: calc(100% - 20px);
    }

    .text {
        display: block;
        margin-left: 100px;
    }

    .headline {
        margin-bottom: 10px;
    }

    @media all and (max-width: 767px) {
        .prodcard-icon {
            color: rgb(51, 51, 51);
            font-size: 53px !important;
            max-height: 50px;
        }

        .prodcard-name {
            margin-left: 0;
            font-size: 14px;
        }

        .prodcard-price {
            font-size: 13px;
        }

        .related-product-link:not(:last-child) {
            border-bottom: 3px solid $color-blueish-black;
        }
    }

    @media all and (min-width: 768px) and (max-width: 1199px) {
        .related-product-link {
            width: calc(50% - 15px);
        }
        .related-product-link:nth-child(2) {
            margin-top: 0;
        }

        .related-product-link:nth-child(3) {
            border-bottom: none;
        }

        .related-product-link:nth-child(odd) {
            margin-right: 15px;
        }

        .related-product-link:nth-child(even) {
            margin-left: 15px;
        }
    }

    @media all and (min-width: 768px) {
        .prodcard-icon {
            position: absolute;
            top: 5px;
            left: calc(50% - 25px);
        }
    }

    @media all and (min-width: 1200px) {
        .link-wrapper {
            padding: 14px 0;
        }
    }

    @media all and (min-width: 1440px) {
        .link-wrapper {
            padding: 17px 0;
        }
    }
</style>
